import SocialSharing from 'vue-social-sharing'

export default ({ Vue }) => {
    Vue.use(SocialSharing)
}
